/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'building/market_open': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M6 10h2v12H6zM9 10h.5v12H9zM11 10h1v12h-1zM13 10h3v12h-3zM17 10h1v12h-1zM20 10h1v12h-1zM22 10h.5v12H22zM24 10h2v12h-2zM4.5 32H0v-4.5h1V31h3.5zM32 32h-4.5v-1H31v-3.5h1zM32 4.5h-1V1h-3.5V0H32zM1 4.5H0V0h4.5v1H1z"/>'
  }
})
